import pricingService from "@/services/pricingService";

export function getInternationalShippingFee(data) {
  return pricingService({
    url: "/shipping/getInternationalShippingFee",
    method: "post",
    data,
  });
}

export function getCountryList() {
  return pricingService({
    url: "/shipping/getCountryList",
    method: "get",
  });
}